// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import router from './router';
import App from './views/App';

import $ from 'jquery';
import  'default-passive-events'
Vue.config.productionTip = false;


// 引入自定义公共插件
// import Public from './assets/js/public'
// Vue.use(Public)

// 引进公共reset.less
import './assets/less/reset.less';
import './assets/less/common.less';
// import './assets/less/var.less'

// 引进UI
// import 'element-ui/lib/theme-default/index.css';
// import 'element-ui/lib/theme-chalk/index.css'
// import ElementUI from 'element-ui';
// Vue.use(ElementUI);
import './plugins/element'

// 引进vuex
import Vuex from 'vuex'

Vue.use(Vuex)
import state from './vuex/state.js'
import getter from './vuex/getter.js'
import mutations from './vuex/mutations.js'

const store = new Vuex.Store({
  state:state,
  getters:getter,
  mutations: mutations,
})

// 全局引入bootstrap.css
// import "../node_modules/bootstrap/dist/css/bootstrap.min.css";

// 全局引入interceptors
import "./assets/js/interceptors.js";


// 开始默认是首页 刷新停留在本页
// (function () {
//   let refreshPage = window.sessionStorage.getItem('refreshPage');
//   console.log('refreshPage', refreshPage)
//   if (refreshPage) {
//     router.push({ path: refreshPage });
//   }
// })();


/* eslint-disable no-new */
fetch("../static/config/vue.config.json?t=" + new Date().getTime())
.then(res => res.json())
.then(data => {
//获取到了数据
console.log('取到的state: ', data)
  new Vue({
    el: '#app',
    router,
    data: function() {
      return {customConfig: data}
    },
    store: new Vuex.Store({
      state:data,
      getters:getter,
      mutations: mutations,
    }),
    template: '<App/>',
    components: { App }
  })
})
.catch(err=>{
//解析错误或者获取数据失败
  console.log('eerr: ' + err)
  new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
  })
})




// WEBPACK FOOTER //
// ./src/main.js